import { styled } from '@material-ui/core';
import MuiTableCell from '@material-ui/core/TableCell';

export const TableCell = styled(MuiTableCell)(() => ({
  padding: 12,
  fontSize: 14,
  fontFamily: 'NeoSansStd',
}));
